import { Breadcrumb } from '../../types';

export const contactsBreadcrumbs: Map<string, Breadcrumb> = new Map([
	[
		'contacts',
		{
			name: 'all',
			to: '/contacts/all',
			i18nKey: 'breadcrumb.contactsAll',
		},
	],
	[
		'contactDetail',
		{
			name: 'View Contact',
			i18nKey: 'pages.contacts.detail.title',
		},
	],
	[
		'members',
		{
			name: 'members',
			to: '/contacts/members',
			i18nKey: 'breadcrumb.contactsMembers',
		},
	],
	[
		'volunteers',
		{
			name: 'volunteers',
			to: '/contacts/volunteers',
			i18nKey: 'breadcrumb.contactsVolunteers',
		},
	],
	[
		'eventParticipants',
		{
			name: 'event-participants',
			to: '/contacts/participants',
			i18nKey: 'breadcrumb.contactsEventParticipants',
		},
	],
	[
		'jobParticipants',
		{
			name: 'job-participants',
			to: '/contacts/job-participants',
			i18nKey: 'breadcrumb.contactsJobParticipants',
		},
	],
	[
		'applications',
		{
			name: 'applications',
			to: '/contacts/applications',
			i18nKey: 'breadcrumb.contactsApplications',
		},
	],
	[
		'contactDonor',
		{
			name: 'contactDonor',
			to: '/contacts/donors',
			i18nKey: 'breadcrumb.contactDonor',
		},
	],
	[
		'contactCase',
		{
			name: 'contactCase',
			to: '/contacts/cases',
			i18nKey: 'breadcrumb.contactCase',
		},
	],
	[
		'newContactCase',
		{
			name: 'newContactCase',
			i18nKey: 'breadcrumb.newContactCase',
		},
	],
	[
		'contactApplicationDetails',
		{
			name: 'contactApplicationDetails',
			i18nKey: 'breadcrumb.contactApplicationDetails',
		},
	],
	[
		'newContact',
		{
			name: 'newContact',
			i18nKey: 'breadcrumb.newContact',
		},
	],
	[
		'newMember',
		{
			name: 'newMember',
			i18nKey: 'breadcrumb.newMember',
		},
	],
	[
		'newVolunteer',
		{
			name: 'newVolunteer',
			i18nKey: 'breadcrumb.newVolunteer',
		},
	],
	[
		'merge',
		{
			name: 'merge',
			to: '/contacts/merge',
			i18nKey: 'breadcrumb.mergeContacts',
		},
	],
]);
